import { ChevronDown } from "lucide-react";
import HelpQ from "./HelpQ";
import { writeDraggedChatContext } from "../utils/chatContextDrag";

const BRAND_ITEMS = [
  {
    title: "Brand assets",
    // subtitle: "Logo, colors, fonts",
    tab: "brand-assets",
  },
  {
    title: "Store profile",
    tab: "store-profile",
  },
  // {
  //   title: "Tone & voice",
  //   subtitle: "Guidelines & examples",
  //   tab: "tone-and-voice",
  // },
  // {
  //   title: "Library",
  //   subtitle: "Files & documents",
  //   tab: "library",
  // },
];

function AppRightRailBrandKnowledge({
  open,
  chatContextPickMode,
  onToggle,
  onNavigateTab,
  styles,
}) {
  return (
    <section className={styles.rightRailSection} data-tour-id="brand-kb">
      <button
        type="button"
        className={styles.rightRailSectionHeader}
        onClick={onToggle}
      >
        <span className={styles.rightRailSectionHeaderTitle}>Brand knowledge base</span>
        <span className={styles.rightRailSectionHeaderActions}>
          <HelpQ stepIndex={11} title="Teach Zeqi your brand" />
          <ChevronDown size={12} strokeWidth={2} aria-hidden="true" />
        </span>
      </button>
      {open ? (
        <div className={styles.rightRailSectionBody}>
          {BRAND_ITEMS.map((item) => (
            <button
              key={item.title}
              type="button"
              className={`${styles.rightRailKnowledgeItem} ${
                chatContextPickMode ? styles.rightRailItemWiggle : ""
              }`}
              onClick={() => onNavigateTab(item.tab)}
              draggable={Boolean(chatContextPickMode)}
              onDragStart={(event) =>
                writeDraggedChatContext(event, {
                  key: item.tab,
                  label: item.title,
                  type: "knowledge",
                  source: "knowledge",
                  sourceLabel: "Brand Knowledge",
                })
              }
            >
              <span>
                <span className={styles.rightRailKnowledgeTitle}>{item.title}</span>
                <span className={styles.rightRailKnowledgeSubtitle}>{item.subtitle}</span>
              </span>
              <span className={styles.rightRailKnowledgeArrow}>›</span>
            </button>
          ))}
        </div>
      ) : null}
    </section>
  );
}

export default AppRightRailBrandKnowledge;
